const leglModalSelectors = {
  cancelButton: `confirm-modal-cancel-btn`,
  confirmButton: `confirm-modal-accept-btn`,
  modal: `legl-modal`,
  alert: `legl-modal-alert`,
  emailSuccessInstructions: `legl-modal-contact-email-success-instructions`,
};

export { leglModalSelectors };
